import React from "react";
import PropTypes from "prop-types";

import { Button } from "semantic-ui-react";

function InformationButtons({
  title,
  disabled,
  loading,
  toPrev,
  cancelButton,
  onSubmit,
}) {
  return (
    <React.Fragment>
      {toPrev && (
        <Button
          style={{ float: "left" }}
          content="Back"
          basic
          onClick={toPrev}
        />
      )}
      {cancelButton}
      <Button
        color="blue"
        content={title}
        type="button"
        disabled={disabled}
        loading={loading}
        onClick={onSubmit}
      />
    </React.Fragment>
  );
}

InformationButtons.propTypes = {
  title: PropTypes.string,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  toPrev: PropTypes.func,
  onSubmit: PropTypes.func.isRequired,
  cancelButton: PropTypes.node,
};

InformationButtons.defaultProps = {
  title: "",
  toPrev: null,
  disabled: false,
  loading: false,
  cancelButton: undefined,
};

export default InformationButtons;
